import React from "react";
import styled from "@emotion/styled";
import { useField } from "formik";
import ReactSelect from "react-select";
import FieldContainer from '../../components/form/Misc/FieldContainer';

const MultiSelect = (props) => {
  const { label, name, options } = props;
  const [field, meta, helpers] = useField(name);
  const { value } = field;
  const {error} = meta
  const { setValue } = helpers;

  const selected = options.filter((item) =>
    typeof value === "string"
      ? item.value === value
      : value.indexOf(item.value) > -1
  );

  return (
    <div className='form-group '>
      <label className='' htmlFor={name}>
        {label}
      </label>
      <FieldContainer className='' errorMessage={error}>
        <ReactSelect
          isMulti={true}
          /* {...field} */
          /* {...props} */
          styles={{
            menu: (provided, state) => ({
              ...provided,
              zIndex: 999,
            }),
          }}
          options={options}
          onChange={(value) => {
            if (value === null) {
              setValue([]);
              return;
            }

            setValue(value.map(v => v.value));
          }}
          defaultValue={selected}
          value={selected}
        />
      </FieldContainer>
    </div>
  );
};

// const FieldContainer = styled.div`
//   position: relative;
//   padding-bottom: "15px";
// `;

export default MultiSelect;
